// extracted by mini-css-extract-plugin
export var content = "_c2-3";
export var list = "_c2-4";
export var settingsContent = "_c2-7";
export var settingsPanel = "_c2-8";
export var state = "_c2-6";
export var triggerBadge = "_c2-2";
export var triggerButton = "_c2-1";
export var triggerShell = "_c2-0";
export var unreadDot = "_c2-5";